import { z } from 'zod';

type TextAreaInputSchemaType = {
  fieldName: string;
  requiredMessage: string;
  maxLength: number;
  maxLengthMessage: string;
};

export const textAreaInputSchema = ({
  fieldName,
  requiredMessage,
  maxLength,
  maxLengthMessage,
}: TextAreaInputSchemaType) =>
  z.object({
    [fieldName]: z
      .string()
      .refine(
        (val) => {
          return val.length > 0;
        },
        {
          message: requiredMessage,
        },
      )
      .refine(
        (val) => {
          return val.length <= maxLength;
        },
        {
          message: maxLengthMessage,
        },
      ),
  });
